export default __webpack_public_path__ + "static/media/gxwksmfm.6ac72570.png";